﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class CasaUserComponent {

    tabla: Tabla = {
        titulo: 'Casas',
        endPoint:'/rest-api/user/casa',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Casa',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                casa: true,
                sortable: true,
                width: 300
            }
        ]
    };

}
